// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.content[data-v-76ad18d6] {\n  padding: 10px;\n}\n[data-v-76ad18d6] .el-dialog__body {\n  padding: 10px 20px;\n}\n", ""]);
// Exports
module.exports = exports;
